module.exports = __webpack_public_path__ + "42cc0e42609ef5ff9e94e22633ba3548.svg";